"use client";
import { jsxs as d, jsx as t } from "react/jsx-runtime";
import { cn as n } from "@deputy-ai/common";
import { forwardRef as E } from "@deputy-ai/common/react";
import { CaretSortIcon as F, ChevronUpIcon as H, ChevronDownIcon as J, CheckIcon as M } from "@radix-ui/react-icons";
import { Select as e } from "radix-ui";
import { Select as ae } from "radix-ui";
import * as c from "react";
const S = e.Root, Q = e.Group, N = e.Value, f = c.forwardRef((a, o) => {
  const { ring: r = !0, className: l, children: s, ...i } = a;
  return /* @__PURE__ */ d(
    e.Trigger,
    {
      ref: o,
      className: n(
        b.trigger,
        r && b.ring,
        l
      ),
      ...i,
      children: [
        s,
        /* @__PURE__ */ t(e.Icon, { asChild: !0, children: /* @__PURE__ */ t(F, { className: "h-4 w-4 opacity-50" }) })
      ]
    }
  );
});
f.displayName = e.Trigger.displayName;
const b = {
  trigger: n(
    "border-input ring-offset-background data-[placeholder]:text-muted-foreground flex h-9 w-full items-center justify-between rounded-md border bg-transparent px-3 py-2 text-sm whitespace-nowrap shadow-sm focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 [&>span]:line-clamp-1"
  ),
  ring: n("focus:ring-ring focus:ring-1")
}, g = c.forwardRef(({ className: a, ...o }, r) => /* @__PURE__ */ t(
  e.ScrollUpButton,
  {
    ref: r,
    className: n(
      "flex cursor-default items-center justify-center py-1",
      a
    ),
    ...o,
    children: /* @__PURE__ */ t(H, {})
  }
));
g.displayName = e.ScrollUpButton.displayName;
const h = c.forwardRef(({ className: a, ...o }, r) => /* @__PURE__ */ t(
  e.ScrollDownButton,
  {
    ref: r,
    className: n(
      "flex cursor-default items-center justify-center py-1",
      a
    ),
    ...o,
    children: /* @__PURE__ */ t(J, {})
  }
));
h.displayName = e.ScrollDownButton.displayName;
const y = c.forwardRef((a, o) => {
  const {
    className: r,
    children: l,
    position: s = "popper",
    portal: i = !0,
    ...p
  } = a;
  function m() {
    return /* @__PURE__ */ d(
      e.Content,
      {
        ref: o,
        className: n(
          "bg-popover text-popover-foreground data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 relative z-70 max-h-[--radix-select-content-available-height] min-w-[8rem] origin-[--radix-select-content-transform-origin] overflow-x-hidden overflow-y-auto rounded-md border border-gray-200 shadow-md",
          s === "popper" && "data-[side=bottom]:translate-y-1 data-[side=left]:-translate-x-1 data-[side=right]:translate-x-1 data-[side=top]:-translate-y-1",
          r
        ),
        position: s,
        ...p,
        children: [
          /* @__PURE__ */ t(g, {}),
          /* @__PURE__ */ t(
            e.Viewport,
            {
              className: n(
                "p-1",
                s === "popper" && "h-[var(--radix-select-trigger-height)] w-full min-w-[var(--radix-select-trigger-width)]"
              ),
              children: l
            }
          ),
          /* @__PURE__ */ t(h, {})
        ]
      }
    );
  }
  if (i === !1) return m();
  const u = i === !0 ? void 0 : i;
  return /* @__PURE__ */ t(e.Portal, { container: u, children: m() });
});
y.displayName = e.Content.displayName;
const v = c.forwardRef(({ className: a, ...o }, r) => /* @__PURE__ */ t(
  e.Label,
  {
    ref: r,
    className: n("px-2 py-1.5 text-sm font-semibold", a),
    ...o
  }
));
v.displayName = e.Label.displayName;
const C = c.forwardRef(({ className: a, children: o, description: r, ...l }, s) => /* @__PURE__ */ d(
  e.Item,
  {
    ref: s,
    className: n(
      "focus:bg-accent focus:text-accent-foreground relative flex w-full cursor-default items-center rounded-sm py-1.5 pr-8 pl-2 text-sm outline-none select-none data-[disabled]:pointer-events-none data-[disabled]:opacity-50",
      a
    ),
    ...l,
    children: [
      /* @__PURE__ */ t("span", { className: "absolute right-2 flex h-3.5 w-3.5 items-center justify-center", children: /* @__PURE__ */ t(e.ItemIndicator, { children: /* @__PURE__ */ t(M, { className: "h-4 w-4" }) }) }),
      /* @__PURE__ */ d("div", { className: "flex flex-1 items-center justify-between", children: [
        /* @__PURE__ */ t(e.ItemText, { children: o }),
        r && /* @__PURE__ */ t("span", { className: "text-muted-foreground ml-2 text-xs", children: r })
      ] })
    ]
  }
));
C.displayName = e.Item.displayName;
const I = c.forwardRef(({ className: a, ...o }, r) => /* @__PURE__ */ t(
  e.Separator,
  {
    ref: r,
    className: n("bg-muted -mx-1 my-1 h-px", a),
    ...o
  }
));
I.displayName = e.Separator.displayName;
const W = E(function(o, r) {
  const {
    items: l,
    itemValueKey: s = "value",
    itemLabelKey: i = "label",
    // root
    value: p,
    defaultValue: m,
    onValueChange: x,
    open: u,
    defaultOpen: R,
    onOpenChange: P,
    dir: j,
    name: B,
    autoComplete: V,
    disabled: D,
    required: L,
    form: T,
    // value
    placeholder: U,
    contentProps: z,
    children: G,
    ...O
  } = o, k = {
    value: p,
    defaultValue: m,
    onValueChange: x,
    open: u,
    defaultOpen: R,
    onOpenChange: P,
    dir: j,
    name: B,
    autoComplete: V,
    disabled: D,
    required: L,
    form: T
  }, K = l == null ? void 0 : l.map((q) => {
    const { [s]: w, [i]: $, ...A } = q;
    return /* @__PURE__ */ t(X.Item, { value: w, ...A, children: $ }, w);
  });
  return /* @__PURE__ */ d(S, { ...k, children: [
    /* @__PURE__ */ t(f, { ref: r, ...O, children: /* @__PURE__ */ t(N, { placeholder: U }) }),
    /* @__PURE__ */ d(y, { ...z, children: [
      K,
      G
    ] })
  ] });
}), X = Object.assign(W, {
  Root: S,
  Group: Q,
  Value: N,
  Trigger: f,
  Content: y,
  Label: v,
  Item: C,
  Separator: I,
  ScrollUpButton: g,
  ScrollDownButton: h
});
export {
  X as Select,
  ae as SelectPrimitive
};
